import { connect } from 'react-redux';
import AppDetails from '../../components/v2/AppDetails/index';
import App from 'models/app';
import { AppType } from '../../constants';
import { translations, translateAll } from 'i18n';

import { uninstallApp } from 'actions/gallery';

interface backUrlType {
  [key: string]: string;
};

const backUrlValues: backUrlType = {
  [AppType.CLOCK]: '/v2/clocks/gallery',
  [AppType.APP]:  '/v2/apps/gallery',
  [AppType.TILE]: '/v2/tiles/gallery'
}

const mapStateToProps = (state: any) => {
  const {
    app: { loading, error, entry },
    features: {
      flags: { showHiggsCU2 }
    },
    installed: { loading: installedLoading },
    installedApps = {},
    currentUser,
    galleryGrant: { userHasGrant, loading: loadingHasGalleryGrant }
  } = state.registry;

  const {
    currentlySyncing,
    deviceInfo: { phoneAppVersion },
    syncMode,
    deeplinkStatus: { isOpen: deeplinkIsOpen }
  } = state.gallery;

  let app;
  let isClock = false;

  if (entry) {
    app = App.selectFromState(entry, state);
    isClock = app?.isClock;
  }

  const {
    page: {
      [isClock ? 'Clock' : 'App']: {
        Navigation: { backText },
        Details: {
          descriptionSectionTitle,
          detailsSectionTitle,
          screenshotsSectionTitle,
        },
      }
    },
  } = translations;

  let showRemove = false;
  let translationsKey = '';
  if (app) {
    if (isClock) {
      translationsKey = app.favorite ? 'Clock' : 'ClockDetails';
    } else {
      // show remove button for apps only
      if (app.isRemovable) {
        showRemove = true;
      }
      translationsKey = 'App';
    }
  }
  const installTexts = translationsKey ? translations.page[translationsKey].InstallButtonState : {};
  const backUrl = app && app.type ? backUrlValues[app.type] : ''

  return {
    loading: loading || loadingHasGalleryGrant || deeplinkIsOpen,
    installedLoading:
      Object.keys(installedApps).length === 0 && installedLoading,
    app,
    userHasGalleryGrant: userHasGrant,
    currentlySyncing,
    phoneAppVersion,
    showHiggsCU2,
    syncMode,
    error,
    currentUser,
    installTexts: translateAll(installTexts),
    descriptionSectionTitle: descriptionSectionTitle(),
    detailsSectionTitle: detailsSectionTitle(),
    screenshotsSectionTitle: screenshotsSectionTitle(),
    showRemove,
    backText: backText(),
    backUrl,
    collectionId: new URLSearchParams(window.location.href.split('?')[1]).get('collectionId'),
  };
};

const mapDispatchToProps = (dispatch: any, { payload: { id } }: { payload: { id: string }}) => ({
  uninstallApp: () => dispatch(uninstallApp(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppDetails);
